import { createContext } from 'react'
import { OrdersService } from './ordersService'

export const OrdersServiceContext = createContext(null as any as OrdersService)
